import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  CmsConfig, I18nModule, PageMetaModule, provideConfig
} from '@spartacus/core';
import { CustomIconsModule } from "../../../../../custom/icons/custom-icons.module";
import { CustomBreadcrumbFormsPageTemplateComponent } from './custom-breadcrumb-formsPageTemplate.component';

@NgModule({
  imports: [CommonModule, RouterModule, PageMetaModule, I18nModule, CustomIconsModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        BreadcrumbFormComponent: {
          component: CustomBreadcrumbFormsPageTemplateComponent,
        },
      },
    }),
  ],
  declarations: [CustomBreadcrumbFormsPageTemplateComponent],
  exports: [CustomBreadcrumbFormsPageTemplateComponent]
})
export class CustomBreadcrumbFormsPageTemplateModule { }
